import React from 'react';
import { Typography } from '@mui/material';

// Campo mais relevante do card — sem rótulo, só destaque na cor primária.
// Texto vem da IA sem tamanho fixo, por isso trunca em uma linha só.
const LeadInterest = ({ interest }) => {
  if (!interest) return null;

  return (
    <Typography
      variant="h6"
      color="primary"
      noWrap
      sx={{ textOverflow: 'ellipsis' }}
    >
      {interest}
    </Typography>
  );
};

export default LeadInterest;
